import { useContext } from 'react';

import { HolidayDatesContext } from '@/contexts/HolidayDatesProvider';

export const useHolidayDates = () => {
  return useContext(HolidayDatesContext);
};
